import { render, staticRenderFns } from "./NotificationToSound.vue?vue&type=template&id=040b3296&"
import script from "./NotificationToSound.vue?vue&type=script&lang=js&"
export * from "./NotificationToSound.vue?vue&type=script&lang=js&"
import style0 from "./NotificationToSound.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports